import React, { useRef } from "react";
const Searchinput = ({
  type,
  name,
  placeholder,
  icon,
  iconStyle,
  cardIcon,
  roundedClass,
}) => {
  const inputRef = useRef(null);

  const handleFocusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="relative">
      <input
        id={name}
        className={`xs:pl-5 xs:!text-[10px] sm:pl-8 sm:!text-[12px] lg:px-12 bg-raisinBlack text-[16px] font-onestRegular w-full xs:py-[3px] sm:py-1 lg:py-2.5 focus:outline-none text-[#707070] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic ${roundedClass}`}
        type={type}
        name={name}
        placeholder={placeholder}
        ref={inputRef}
      />
      {icon && (
        <img
          onClick={handleFocusInput}
          className={`absolute xs:left-1.5 sm:left-3 lg:left-5 xs:top-[15px] top-1/2 transform -translate-y-1/2 ${iconStyle}`}
          src={icon}
          alt={`${name} icon`}
        />
      )}
      {cardIcon && (
        <img
          onClick={handleFocusInput}
          className="absolute sm:right-3 lg:right-6 top-1/2 transform -translate-y-1/2 sm:w-7 sm:h-4 h-6 w-10"
          src={cardIcon}
          alt={`${name} cardIcon`}
        />
      )}
    </div>
  );
};

export default Searchinput;
